import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  CLOSED_CONCILIATION_COUNT_REPORT,
  CLOSED_CONCILIATION_REPORT,
  DAY_LACK_REPORT,
  LACK_REPORT,
  OPEN_CONCILIATION_COUNT_REPORT,
} from "@/constants/conciliaton-report-types";
import { ReportGenerator } from "./report-generator";

const tabData = [
  {
    value: "falta-conciliacao",
    label: "Falta de Conciliação",
    reportType: LACK_REPORT,
    title: "Relatório de Falta de Conciliação",
    description:
      "Listagem de conciliações com filtros personalizados.",
  },
  {
    value: "falta-por-dia",
    label: "Falta por Dia",
    reportType: DAY_LACK_REPORT,
    title: "Relatório de Falta por Dia",
    description:
      "Listagem de lojas e datas com conciliações em aberto, pendentes ou conciliadas, conforme filtros aplicados.",
  },
  {
    value: "qtd-por-responsavel",
    label: "Qtd. Aberta",
    reportType: OPEN_CONCILIATION_COUNT_REPORT,
    title: "Quantidade de Conciliações Abertas por Responsável",
    description:
      "Listagem da quantidade de conciliações restantes por responsável.",
  },
  {
    value: "conciliacoes-realizadas",
    label: "Conciliações Fechadas",
    reportType: CLOSED_CONCILIATION_REPORT,
    title: "Relatório de Conciliações Fechadas",
    description: `Listagem de conciliações realizadas por
            responsável, incluindo data da conciliação, data de divergência,
            quem conciliou e quando.`,
  },
  {
    value: "qtd-realizadas",
    label: "Qtd. Fechadas",
    reportType: CLOSED_CONCILIATION_COUNT_REPORT,
    title: "Quantidade de Conciliações Fechadas por Responsável",
    description:
      "Listagem da quantidade de conciliações fechadas por responsável.",
  },
];

export default function ReportTabs() {
  return (
    <div className="w-full">
      <Tabs defaultValue="falta-conciliacao" className="w-full">
        <TabsList className="grid w-full grid-cols-5 rounded-lg bg-white border p-1">
          {tabData.map((tab) => (
            <TabsTrigger
              key={tab.value}
              className="rounded-md transition-all data-[state=active]:bg-[#2E0D1E] data-[state=active]:text-white data-[state=active]:shadow-sm"
              value={tab.value}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        {tabData.map((tab) => (
          <TabsContent key={tab.value} value={tab.value}>
            <ReportGenerator
              reportType={tab.reportType}
              title={tab.title}
              description={tab.description}
            />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
